import { render } from "./ContactForm.vue?vue&type=template&id=20fdd3d6&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=20fdd3d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20fdd3d6"

export default script